import { useState, useEffect, Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchPracticeListRequest,
  setPaperName,
  setPlannerDetails,
  setSelectedType,
  setTestDetails,

} from "../../../redux/exam/examSlice";
import { useHistory } from "react-router-dom";
import "./PracticeDashboard.css";
import images from "../../../utilities/images/images";
import Modal from "../../../shared/components/Modal/Modal";
import ProgressBar from "../../../custom_utilities/ProgressBar/ProgressBar";

const PracticeDashboard = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { practiceList, testDetails, loading, error } = useSelector(
    (state) => state.examSlice
  );

  const [modalOpen, setModalOpen] = useState(false);
  const [selectedSublist, setSelectedSublist] = useState(null);
  const [selectedItemName, setSelectedItemName] = useState("");

  // Fetch practice list when the component mounts
  useEffect(() => {
    dispatch(fetchPracticeListRequest());
  }, [dispatch]);

  const handleItemClick = (item, e, section) => {
    e.stopPropagation();
    dispatch(setPaperName(item.name));
    if (item?.type) {
      dispatch(setSelectedType(item.type));

      dispatch(
        setTestDetails({
          ...testDetails,
          format: item.type,
        })
      );
    }

    if (item?.name?.toLowerCase().includes("pyq")) {
      if (item.sublist) {
        setSelectedSublist(item);
        setSelectedItemName(item.name);
        setModalOpen(true);
      }
      return;
    }
    if (
      item?.sublist &&
      Array.isArray(item.sublist) &&
      item.sublist.length > 0
    ) {
      setSelectedSublist(item);
      setSelectedItemName(item.name);
      setModalOpen(true);
      return;
    }

    if (section === "main_practice_dashboard") {
      const name = item?.name?.toLowerCase();
      const itemId = Number(item?.id);
      const isExamCrackerMain =
        itemId === 9 || name.includes("exam cracker (jee mains)");
      const isExamCrackerAdvanced =
        itemId === 8 ||
        name.includes("exam cracker (jee advanced)") ||
        name.includes("exam cracker (jee advance)");
      if (isExamCrackerMain) {
        const paperTypeId = itemId || 9;
        dispatch(setSelectedType("main"));
        dispatch(
          setTestDetails({
            ...(testDetails || {}),
            format: "main",
          })
        );
        dispatch(
          setPlannerDetails({
            planner_id: item?.planner_id || "",
            planner_type_id: item?.planner_type_id || "",
            category_id: paperTypeId,
            id: paperTypeId,
            type: "topic wise",
          })
        );
        history.push("/practice/topic-wise");
        return;
      }
      if (isExamCrackerAdvanced) {
        const paperTypeId = itemId || 8;
        dispatch(setSelectedType("adv"));
        dispatch(
          setTestDetails({
            ...(testDetails || {}),
            format: "adv",
          })
        );
        dispatch(
          setPlannerDetails({
            planner_id: item?.planner_id || "",
            planner_type_id: item?.planner_type_id || "",
            category_id: paperTypeId,
            id: paperTypeId,
            type: "topic wise",
          })
        );
        history.push("/practice/topic-wise");
        return;
      }
    }

    if (section === "enhance_your_practice") {
      const name = item?.name?.toLowerCase();
      if (name.includes("conceptual problem sheets")) {
        history.push("/cps");
        return;
      }
      if (name.includes("adaptive cps")) {
        history.push("/create-adaptive-cps");
        return;
      }
      if (name.includes("exams")) {
        history.push("/exam");
        return;
      }
      if (name.includes("bitsat")) {

        dispatch(
          setPlannerDetails({
            planner_id: item.planner_id,
            planner_type_id: item.planner_type_id,
            category_id: item.category_id || "",
            id: item.id || "",
            type: item.type || "",
          })
        );

        history.push("/practice/paper-listing");

        return;
      }
      if (name.includes("ncert")) {
        history.push("/ncert");
        return;
      }
      if (name.includes("mock")) {



        dispatch(
          setPlannerDetails({
            planner_id: item.planner_id,
            planner_type_id: item.planner_type_id,
            category_id: item.category_id || "",
            id: item.id || "",
            type: item.type || "",
          })
        );

        history.push("/practice/paper-listing");
        return;
      }
      if (name.includes("unlimited question bank")) {
        history.push("/question_bank");
        return;
      }
    }

    if (item?.planner_id && item?.planner_type_id) {
      dispatch(
        setPlannerDetails({
          planner_id: item.planner_id,
          planner_type_id: item.planner_type_id,
          category_id: item.category_id || "",
          id: item.id || "",
          type: item.type || "",
        })
      );

      if (section === "main_practice_dashboard") {
        history.push("/practice/paper-listing");
      } else {
        history.push("/subjects");
      }
      return;
    }

    history.push("/practice/paper-listing");
  };

  // Handle item click inside the modal
  const handleModalItemClick = (subitem) => {
    setModalOpen(false);

    // dispatch(setSelectedType(subitem.type?.toLowerCase()));
    dispatch(
      setSelectedType(
        selectedItemName.toLowerCase().includes("advance") ? "adv" : "main"
      )
    );

    dispatch(
      setPlannerDetails({
        planner_id: subitem.planner_id,
        planner_type_id: subitem.planner_type_id,
        category_id: subitem.category_id || "",
        id: subitem.id || "",
        type: subitem?.type?.toLowerCase(),
      })
    );

    const type = subitem?.type?.toLowerCase();

    if (type === "year wise") {
      history.push(`/practice/paper-listing?type=Year Wise`);
    } else if (type === "topic wise") {
      history.push("/practice/topic-wise");
    } else {
      history.push("/practice/paper-listing");
    }
  };

  // Handle section click for navigation
  const handleSectionClick = (e, section) => {
    if (e.target.closest(".dashboard-grid-item")) return;

    if (section === "main_practice_dashboard") {
      history.push("/practice/paper-listing");
    }

    if (section === "enhance_your_practice") {
      history.push("/subjects");
    }
  };

  // Render section with items
  const renderSection = (section, sectionType) => {
    if (!section) return null;

    return (
      <>
        <h2 className="section-title" style={{ paddingLeft: "20px" }}>
          {section?.title}
        </h2>
        <div
          className="section"
          style={{ paddingLeft: "20px" }}
          onClick={(e) => handleSectionClick(e, sectionType)}
        >
          <div className="dashboard-grid">
            {section?.data?.map((item, index) => (
              <div
                key={item?.id + index}
                className="dashboard-grid-item"
                onClick={(e) => handleItemClick(item, e, sectionType)}
                style={{ cursor: "pointer" }}
              >
                <div className="icon-container">
                  <img
                    src={item?.icon || item?.pimage}
                    alt={item?.name || item?.sublistName}
                    className="icon"
                  />
                </div>

                <div className="item-details">
                  <p className="item-name">{item?.name || item?.sublistName}</p>
                  {item?.progress_percent !== null &&
                    item?.progress_percent !== undefined && (
                      <div className="progress-bar-bg">
                        <div
                          className="progress-bar-fill"
                          style={
                            Number(item.progress_percent) === 0
                              ? {
                                width: "8px",
                                height: "8px",
                                borderRadius: "50%",
                                backgroundColor: "#D5D7DA",
                              }
                              : {
                                width: `${Number(item.progress_percent)}%`,
                              }
                          }
                        />
                      </div>
                    )}

                </div>

                {item?.tag && (
                  <span
                    className="item-tag"
                    style={{
                      backgroundColor: item?.tag_color,
                      color: "#fff",
                    }}
                  >
                    {item?.tag}
                  </span>
                )}
              </div>
            ))}
          </div>
        </div>
      </>
    );
  };

  // Loading and error states
  if (loading) return <div className="loading">Loading...</div>;
  if (error) return <div className="error">{error}</div>;

  return (
    <div className="practice-dashboard-wrapper">
      <Fragment>
        {/* Navigation Header */}
        <div id="practice-nav">
          <div>
            <img
              style={{ width: 22, height: 22, cursor: "pointer" }}
              src={images.new_backarrow}
              alt="Back"
              onClick={() => history.push("/user_dashboard")}
            />
          </div>
          <div style={{ marginLeft: "25px" }} id="practice-title">
            Practice
          </div>
        </div>

        {/* Main Practice Dashboard */}
        <div onClick={(e) => handleSectionClick(e, "main_practice_dashboard")}>
          {practiceList?.main_practice_dashboard && (
            <div>
              {renderSection(
                practiceList?.main_practice_dashboard,
                "main_practice_dashboard"
              )}
            </div>
          )}
        </div>

        {/* Enhance Your Practice Section */}
        <div onClick={(e) => handleSectionClick(e, "enhance_your_practice")}>
          {practiceList?.enhance_your_practice && (
            <div>
              {renderSection(
                practiceList?.enhance_your_practice,
                "enhance_your_practice"
              )}
            </div>
          )}
        </div>

        {/* Modal for Sublist Items */}
        <Modal
          isOpen={modalOpen}
          onClose={() => setModalOpen(false)}
          width="auto"
          height="auto"
          backgroundColor="#fff"
        >
          <div className="modal-item-content">
            {selectedItemName && (
              <h3 className="modal-title" id="modal-title-left">
                {selectedItemName}
              </h3>
            )}

            {selectedSublist?.sublist?.map((subitem, index) => (
              <div
                key={subitem.id + index}
                className="modal-item"
                onClick={() => handleModalItemClick(subitem)}
                style={{ cursor: "pointer" }}
              >
                <div className="modal-item-header">
                  <div className="modal-icon-container">
                    <img
                      src={subitem?.image}
                      alt={subitem?.sublistName}
                      className="modal-icon"
                    />
                  </div>

                  <div className="modal-item-details">
                    <p
                      className="modal-item-name"
                      style={{ marginBottom: "0px" }}
                    >
                      {subitem?.sublistName}
                    </p>

                    <p
                      className="modal-item-description"
                      style={{ marginBottom: "0px" }}
                    >
                      {subitem?.description}
                    </p>

                    {/* <ProgressBar
                    progress={subitem?.progress_percent}
                    color={subitem?.color}
                    height={"10px"}
                  /> */}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </Modal>
      </Fragment>
    </div>
  );
};

export default PracticeDashboard;
